const NO_SAVED_SEARCHES_TEMPLATE_PC = `
    <div class="container">
        <div class="row-deine-suchen base-row row">
            <div class="col-xs-12">
                <h3 class="text-center stripe-title">
                    Deine Suchen
                </h3>
            </div>

            <div class="col-xs-12">
                <div class="static-card">
                    <div>
                        <div class="text-center column-heading">
                            <small><strong>Du hast zur Zeit keine Suchen gespeichert.</strong></small>
                        </div>

                        <div class="empty-merkzettel-info text-center row">
                            <div class="col-xs-12 col-md-8 col-md-offset-2">
                                <p class="text-center">
                                    Verwende <strong>Suche speichern</strong>
                                    im Anzeigenmarkt, um bis zu zehn Suchen zu speichern.
                                    So hast du sie auf allen deinen Geräten immer zur Verfügung und kannst die jederzeit abrufen.
                                </p>
                                <br>
                            </div>

                            <div class="col-xs-12"></div>
                            <div class="further-button col-xs-6 col-xs-offset-3">
                                <a href="/sex-anzeigen" class="btn btn-lg btn-ladies-primary btn-block "><strong>Zum Anzeigenmarkt</strong></a>
                            </div>
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
            </div>
        </div>
    </div>`

const NO_SAVED_SEARCHES_TEMPLATE_MOBILE = `
    <div class="container">
        <div class="row-deine-suchen base-row row">
            <div class="col-xs-12">
                <div class="static-card">
                    <div>
                        <div class="text-center column-heading">
                            <p class="fnt-8 wei-4 p-15-b">Du hast zur Zeit keine Suchen gespeichert!</p>
                        </div>

                        <div class="empty-merkzettel-info text-center row">
                            <div class="col-xs-12 col-md-8 col-md-offset-2">
                                <p class="text-center">
                                    Verwende <strong>Suche speichern</strong>
                                    im Anzeigenmarkt, um bis zu zehn Suchen zu speichern.
                                    So hast du sie auf allen deinen Geräten immer zur Verfügung und kannst die jederzeit abrufen.
                                </p><br>
                            </div>

                            <div class="further-button col-xs-12">
                                <a href="/sex-anzeigen" class="btn btn-lg btn-ladies-primary btn-block "><strong>Zum Anzeigenmarkt</strong></a>
                            </div>
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
            </div>
        </div>
    </div>`

const REMOVE_ALL_BUTTON_MOBILE = `
    <button class="btn btn-default btn-actions user-search-delete-all blue-link" id="empty-user-searches-button" data-toggle="modal" data-target="#empty-user-searches-modal">
        <span class="icon default inline before-text icon-12 icon-empty">
            <svg viewBox="0 0 20 20">
                <path d="M0.020 18.373l8.383-8.383-8.383-8.383 1.607-1.607 8.383 8.383 8.363-8.363 1.607 1.607-8.383 8.383 8.383 8.383-1.607 1.607-8.383-8.383-8.363 8.363z"></path>
            </svg>
        </span> Alle entfernen
    </button>`

const REMOVE_ALL_BUTTON_PC = `
    <button class="btn btn-block btn-default btn-none text-left" id="empty-user-searches-button" data-toggle="modal" data-target="#empty-user-searches-modal">
        <span class="icon dark inline before-text icon-12 icon-empty">
            <svg viewBox="0 0 20 20">
                <path d="M0.020 18.373l8.383-8.383-8.383-8.383 1.607-1.607 8.383 8.383 8.363-8.363 1.607 1.607-8.383 8.383 8.383 8.383-1.607 1.607-8.383-8.383-8.363 8.363z"></path>
            </svg>
        </span> Alle entfernen
    </button>`

export function getNoSearchedTemplate(): string {
    let html = NO_SAVED_SEARCHES_TEMPLATE_PC

    if (SiteInfo.isMobileVersion) {
        html = NO_SAVED_SEARCHES_TEMPLATE_MOBILE
    }
    return html
}

export function getRemoveAllButton(): string {
    let html = REMOVE_ALL_BUTTON_PC

    if (SiteInfo.isMobileVersion) {
        html = REMOVE_ALL_BUTTON_MOBILE
    }
    return html
}
export function getErrorInformationText(): string {
    let html = PC_ERROR_INFORMATION_TEXT

    if (SiteInfo.isMobileVersion) {
        html = MOBILE_ERROR_INFORMATION_TEXT
    }
    return html
}

export const PC_ERROR_INFORMATION_TEXT = `<div id="error-information" role="alert" class="alert user-search-alert alert-warning">Es ist ein Fehler aufgetreten. Bitte aktualisiere die Seite oder versuche es später noch einmal.</div>`
export const MOBILE_ERROR_INFORMATION_TEXT = `<div id="error-information" role="alert" class="alert user-search-alert alert-warning">Es ist ein Fehler aufgetreten. <br> Bitte aktualisiere die Seite oder versuche es später noch einmal.</div>`
export const INFORMATION_TEXT = `<div id="information-count-searches" data-count="0" role="status" class="alert user-search-alert alert-warning"></div>`

export const SAVED_SEARCH_TEMPLATE = `
    <div class="item" data-id="{DATA_ID}" {IS_MOBILE_LOCATION}>
        <a href="{HREF}" class="user-search-entry item-inner">
            <p class="search-list-date">{DATE}</p>
            <p class="text-heading text-bold">{DATA_TITLE}</p>
            <p class="search-list-label">
                {REPLACE_SEARCH_LIST_LABEL}
            </p>

        </a>
        <a href="#" class="remove-single text-left" data-id="{DATA_ID}" data-name="{TITLE}" data-toggle="modal" data-target="#delete-user-search-modal"
           data-callback="removeElementCard" title="Gespeicherte Suche entfernen">
            <span class="icon default hover-primary block lower icon-16">
                <svg viewBox="0 0 20 20">
                    <path d="M7.5 0h3.75c0.688 0 1.25 0.563 1.25 1.25v1.25h2.5c0.688 0 1.25 0.563 1.25 1.25v1.25c0 0.687-0.563 1.25-1.25 1.25v12.5c0 0.687-0.563 1.25-1.25 1.25h-8.75c-0.687 0-1.25-0.563-1.25-1.25v-12.5c-0.688 0-1.25-0.563-1.25-1.25v-1.25c0-0.688 0.563-1.25 1.25-1.25h2.5v-1.25c0-0.688 0.563-1.25 1.25-1.25zM8.75 8.75v7.5h1.25v-7.5h-1.25zM11.25 8.75v7.5h1.25v-7.5h-1.25zM6.25 8.75v7.5h1.25v-7.5h-1.25zM13.75 6.25h-8.75v12.5h8.75v-12.5zM11.25 2.5v-1.25h-3.75v1.25h3.75zM3.75 3.75v1.25h11.25v-1.25h-11.25z"></path>
                </svg>
            </span> {REPLACE_DELETE_TEXT}
        </a>
    </div>`
